import { IconSvg } from '../../types'

export const Circle: IconSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    stroke="none"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
  </svg>
)
